import { render, staticRenderFns } from "./selected-room.vue?vue&type=template&id=6ac77366&scoped=true"
import script from "./selected-room.vue?vue&type=script&lang=js"
export * from "./selected-room.vue?vue&type=script&lang=js"
import style0 from "./selected-room.vue?vue&type=style&index=0&id=6ac77366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac77366",
  null
  
)

export default component.exports